/*
 * Trafford variant selector (strap/merch buy hero).
 * Reads the product's variants JSON and wires the option controls (size pills,
 * color swatches). On any change it resolves the matching variant and updates the
 * price, the Add-to-cart button (id + enabled/label), the selected color name, and
 * greys out option values whose combination has no available variant.
 * No-op for single-variant products (no controls rendered).
 */
(function () {
  function money(cents) {
    var d = cents / 100;
    return d % 1 === 0 ? '$' + d : '$' + d.toFixed(2);
  }

  function setup(sec) {
    if (sec.dataset.vsInit === '1') return;
    var dataEl = sec.querySelector('[data-twc-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var groups = [].slice.call(sec.querySelectorAll('[data-twc-opt]'));
    var priceEl = sec.querySelector('[data-twc-price]');
    var idInput = sec.querySelector('[data-twc-variant-id]');
    var cta = sec.querySelector('[data-twc-cta]');
    var ctaLabel = sec.querySelector('[data-twc-cta-label]');
    var mainImg = sec.querySelector('[data-twc-main]');
    var buyForm = sec.querySelector('[data-twc-vform]');
    var notifyBtn = sec.querySelector('[data-twc-notify]');

    var selected = {};
    groups.forEach(function (g) {
      var pos = parseInt(g.dataset.optPosition, 10);
      var sel = g.querySelector('[data-twc-value].is-selected') || g.querySelector('[data-twc-value]');
      selected[pos] = sel ? sel.getAttribute('data-twc-value') : null;
    });

    function matches(v, sel) {
      for (var pos in sel) {
        if (v.options[pos - 1] !== sel[pos]) return false;
      }
      return true;
    }
    function find(sel) {
      for (var i = 0; i < variants.length; i++) { if (matches(variants[i], sel)) return variants[i]; }
      return null;
    }
    function comboAvailable(pos, value) {
      var test = {};
      for (var k in selected) test[k] = selected[k];
      test[pos] = value;
      for (var i = 0; i < variants.length; i++) {
        if (matches(variants[i], test) && variants[i].available) return true;
      }
      return false;
    }

    function render() {
      groups.forEach(function (g) {
        var pos = parseInt(g.dataset.optPosition, 10);
        var selEl = g.querySelector('[data-twc-opt-selected]');
        [].slice.call(g.querySelectorAll('[data-twc-value]')).forEach(function (btn) {
          var val = btn.getAttribute('data-twc-value');
          var isSel = selected[pos] === val;
          btn.classList.toggle('is-selected', isSel);
          btn.setAttribute('aria-selected', isSel);
          btn.classList.toggle('is-unavailable', !comboAvailable(pos, val));
          if (isSel && selEl) selEl.textContent = val;
        });
      });
      var v = find(selected);
      // Toggle buy form vs "Get notified": show notify whenever the selected
      // variant is missing or sold out, so the button is never a dead end.
      var available = !!(v && v.available);
      if (buyForm && notifyBtn) {
        buyForm.hidden = !available;
        notifyBtn.hidden = available;
      }
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (cta) cta.disabled = !v.available;
        if (ctaLabel) ctaLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
        // swap the main image to the variant's image (e.g. selecting a colour)
        if (mainImg && v.featured_image && v.featured_image.src) mainImg.src = v.featured_image.src;
      } else {
        if (cta) cta.disabled = true;
        if (ctaLabel) ctaLabel.textContent = 'Unavailable';
      }
    }

    groups.forEach(function (g) {
      var pos = parseInt(g.dataset.optPosition, 10);
      g.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-twc-value]');
        if (!btn) return;
        selected[pos] = btn.getAttribute('data-twc-value');
        render();
      });
    });

    // Route Add-to-cart through Horizon's native cart so the drawer opens.
    // If the helper module isn't loaded yet, let the native form POST proceed.
    if (buyForm) {
      buyForm.addEventListener('submit', function (e) {
        if (!window.traffordAddToCart) return;
        e.preventDefault();
        var vid = idInput ? idInput.value : null;
        if (!vid) return;
        if (cta) cta.disabled = true;
        function done() { if (cta) cta.disabled = false; render(); }
        window.traffordAddToCart([{ id: vid, quantity: 1 }], { sourceId: 'twc-strap' })
          .then(done)
          .catch(done);
      });
    }

    render();
    sec.dataset.vsInit = '1';
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-twc-buy]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
